var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToiletPaper(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.182 18.287H5.045V8.416a2.62 2.62 0 012.62-2.621h8.325l-1.808 3.349v9.143z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.182 18.287l-1.523-.882-1.523.882-1.523-.882-1.522.882-1.523-.882-1.523.882V8.416a2.62 2.62 0 012.62-2.621h8.325l-1.808 3.349v9.143z",
    stroke: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.196 9.264c0 1.916-1.122 3.47-2.507 3.47s-2.507-1.554-2.507-3.47c0-1.916 1.122-3.47 2.507-3.47s2.507 1.554 2.507 3.47",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.196 9.264c0 1.916-1.122 3.47-2.507 3.47s-2.507-1.554-2.507-3.47c0-1.916 1.122-3.47 2.507-3.47s2.507 1.554 2.507 3.47z",
    stroke: "#666",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M16.688 12.734h-2.507"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666",
    d: "M16.688 12.734h-2.507"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.648 9.264c0 .733-.43 1.328-.96 1.328s-.959-.595-.959-1.328c0-.733.43-1.328.96-1.328s.96.595.96 1.328",
    fill: "#FFF"
  }))));
}
export default SvgToiletPaper;